import bulkExpressionParser from '../simpleScript/expressionParser/bulkExpressionParser';

export default async function(
    functionObj={},
    variableObject={},
    parameterObject={},
    functionMap={},
    variableIdMap={}
){
    try{
        const {inhouz_reserved_parameters_xyzh={}} = parameterObject;
        const {websocketFunction} = inhouz_reserved_parameters_xyzh;
        const {
            executionObject={}
        } = functionObj;

        let parsedParameters = await bulkExpressionParser({
            executionObject,
            variableObject,
            parameterObject,
            functionMap,
            variableIdMap,
            useAllFields : true
        });
    
        let resolvedParams = parsedParameters['accumulator'];
        if(
            !resolvedParams.channels ||
            !Array.isArray(resolvedParams.channels)
        ){
            console.log('Invalid websocket channel(s)');
            return {
                updatedVariableObject : variableObject,
                hasError : true,
                errorPayload : 'Invalid websocket channel(s).',
                hasReturnStatement : false,
                returnStatement : undefined
            }
        }

        if(websocketFunction){
            websocketFunction({
                action : 'sendWebsocketMessage',
                channels : resolvedParams.channels,
                data : resolvedParams.data
            });
        }

        return {
            hasError : false,
            errorPayload : undefined,
            hasReturnStatement : false,
            returnStatement : undefined,
            updatedVariableObject : variableObject
        }
    }catch(e){
        console.log('/utils/functionParser/general/functionTypeParser/sendWebsocketMessageParser catch block error', e);
        return {
            updatedVariableObject : variableObject,
            hasError : true,
            errorPayload : e.stack,
            hasReturnStatement : false,
            returnStatement : undefined
        } 
    }
}